import styled from '@emotion/styled';
import { AccountContent } from 'src/domains/players/webview/components/Account/accountParts/Account.style';

export const DateRangeFormWrapper = styled(AccountContent, { label: 'DateRangeFormWrapper' })`
    padding: 0 16px 16px;
`;
